import { AuthService } from '@/services/AuthService'
import { inject, computed } from 'vue'

export const useAuth = () => { 
  const auth = inject('authService') as AuthService

  return {
    auth: auth,
    currentUser: computed(() => auth.currentUser),
    isAuthenticated: computed(() => auth.isAuthenticated),
    isAdmin: computed(() => auth.isAdmin),
    isEmployee: computed(() => auth.isEmployee),
    isSales: computed(() => auth.isSales),
    isProjectManager: computed(() => auth.isProjectManager),
    isEstimator: computed(() => auth.isEstimator),
    isFinance: computed(() => auth.isFinance),
    isSubcontractor: computed(() => auth.isSubcontractor),
    isCustomer: computed(() => auth.isCustomer),
    isVerified: computed(() => auth.isVerified),
    userRoles: computed(() => auth.userRoles),
    loginOrSignUpGoogle: auth.loginOrSignUpGoogle,
    loginEmail: auth.loginEmail,
    logout: auth.logout,
    registerEmailUser: auth.registerEmailUser,
  }
}